export default "__VITE_ASSET__DbVQbDXc__"